import { lazy, Suspense } from 'react';

// Lazy load world effects for better performance
const FruitGardenEffect = lazy(() => import('./FruitGardenEffect'));
const IceWorldEffect = lazy(() => import('./IceWorldEffect'));
const ChainRealmEffect = lazy(() => import('./ChainRealmEffect'));
const ChocolateFactoryEffect = lazy(() => import('./ChocolateFactoryEffect'));
const HoneyHiveEffect = lazy(() => import('./HoneyHiveEffect'));
const LavaWorldEffect = lazy(() => import('./LavaWorldEffect'));
const PointWorldEffect = lazy(() => import('./PointWorldEffect'));
const DarkForestEffect = lazy(() => import('./DarkForestEffect'));
const OceanDepthsEffect = lazy(() => import('./OceanDepthsEffect'));
const FrozenPeaksEffect = lazy(() => import('./FrozenPeaksEffect'));
const AncientRuinsEffect = lazy(() => import('./AncientRuinsEffect'));
const VolcanicCoreEffect = lazy(() => import('./VolcanicCoreEffect'));
const MoonlightGardenEffect = lazy(() => import('./MoonlightGardenEffect'));
const AlchemistLabEffect = lazy(() => import('./AlchemistLabEffect'));
const CircusCarnivalEffect = lazy(() => import('./CircusCarnivalEffect'));
const PirateShipwreckEffect = lazy(() => import('./PirateShipwreckEffect'));
const CherryBlossomEffect = lazy(() => import('./CherryBlossomEffect'));
const StormKingdomEffect = lazy(() => import('./StormKingdomEffect'));
const MushroomCavernEffect = lazy(() => import('./MushroomCavernEffect'));
const CasinoRoyaleEffect = lazy(() => import('./CasinoRoyaleEffect'));
const CosmicNebulaEffect = lazy(() => import('./CosmicNebulaEffect'));
const CrystalParadiseEffect = lazy(() => import('./CrystalParadiseEffect'));
const RoyalCitadelEffect = lazy(() => import('./RoyalCitadelEffect'));

// World configurations with gradients
export const PARALLAX_CONFIGS = {
  1: { farSky: { gradient: 'linear-gradient(180deg, #7EC8E3 0%, #B8E4F0 25%, #D4F1F9 45%, #E8F5E9 65%, #C5E1A5 85%, #8BC34A 100%)', effect: 'fruitGarden' }},
  2: { farSky: { gradient: 'linear-gradient(180deg, #0a0a1a 0%, #0F172A 20%, #1E3A5F 50%, #3B82F6 75%, #7DD3FC 100%)', effect: 'iceWorld' }},
  3: { farSky: { gradient: 'linear-gradient(180deg, #1a1a1a 0%, #2d2d2d 30%, #4a4a4a 60%, #6b6b6b 100%)', effect: 'chainRealm' }},
  4: { farSky: { gradient: 'linear-gradient(180deg, #4a2c2a 0%, #6b3a30 25%, #8B4513 50%, #D2691E 75%, #F4A460 100%)', effect: 'chocolateFactory' }},
  5: { farSky: { gradient: 'linear-gradient(180deg, #87CEEB 0%, #FFD700 40%, #FFA500 70%, #FF8C00 100%)', effect: 'honeyHive' }},
  6: { farSky: { gradient: 'linear-gradient(180deg, #1a0a0a 0%, #3d0a0a 25%, #8B0000 50%, #FF4500 75%, #FF6B00 100%)', effect: 'lavaWorld' }},
  7: { farSky: { gradient: 'linear-gradient(180deg, #0a0a20 0%, #1a1a40 30%, #2E1065 60%, #7C3AED 85%, #A78BFA 100%)', effect: 'pointWorld' }},
  8: { farSky: { gradient: 'linear-gradient(180deg, #000000 0%, #0a0a0a 20%, #1a1a2e 50%, #1f1f3a 75%, #0d1f0d 100%)', effect: 'darkForest' }},
  9: { farSky: { gradient: 'linear-gradient(180deg, #001830 0%, #003366 25%, #006699 50%, #0099cc 75%, #004466 100%)', effect: 'oceanDepths' }},
  10: { farSky: { gradient: 'linear-gradient(180deg, #0a0a20 0%, #1a2a4a 25%, #2a4a7a 50%, #87CEEB 75%, #E0F7FA 100%)', effect: 'frozenPeaks' }},
  11: { farSky: { gradient: 'linear-gradient(180deg, #1a0a00 0%, #4a2000 25%, #8B4513 50%, #DEB887 75%, #F5DEB3 100%)', effect: 'ancientRuins' }},
  12: { farSky: { gradient: 'linear-gradient(180deg, #0a0000 0%, #2a0000 20%, #5a0000 40%, #8B0000 60%, #FF4500 80%, #FFFF00 100%)', effect: 'volcanicCore' }},
  13: { farSky: { gradient: 'linear-gradient(180deg, #0a0a20 0%, #1a1a40 30%, #2a2a5a 50%, #4a4a8a 70%, #6a6aaa 100%)', effect: 'moonlightGarden' }},
  14: { farSky: { gradient: 'linear-gradient(180deg, #0a1a0a 0%, #1a3a1a 30%, #2a5a2a 50%, #10B981 70%, #34D399 100%)', effect: 'alchemistLab' }},
  15: { farSky: { gradient: 'linear-gradient(180deg, #2a0a3a 0%, #4a1a5a 25%, #7C3AED 50%, #A855F7 75%, #E879F9 100%)', effect: 'circusCarnival' }},
  16: { farSky: { gradient: 'linear-gradient(180deg, #1a2a3a 0%, #2a3a4a 25%, #3a4a5a 50%, #4a6a8a 75%, #5a8aaa 100%)', effect: 'pirateShipwreck' }},
  17: { farSky: { gradient: 'linear-gradient(180deg, #fff0f5 0%, #ffb6c1 30%, #ff69b4 60%, #ff1493 85%, #c71585 100%)', effect: 'cherryBlossom' }},
  18: { farSky: { gradient: 'linear-gradient(180deg, #0a0a15 0%, #1a1a2a 25%, #2a2a4a 50%, #4a4a6a 75%, #6a6a8a 100%)', effect: 'stormKingdom' }},
  19: { farSky: { gradient: 'linear-gradient(180deg, #0a0a1a 0%, #1a0a2a 30%, #2a1a4a 50%, #4a2a6a 70%, #6a3a8a 100%)', effect: 'mushroomCavern' }},
  20: { farSky: { gradient: 'linear-gradient(180deg, #0a0a0a 0%, #1a0a0a 25%, #2a1a1a 50%, #8B0000 70%, #FFD700 100%)', effect: 'casinoRoyale' }},
  21: { farSky: { gradient: 'linear-gradient(180deg, #000005 0%, #0a0a20 20%, #1a1a40 40%, #2E1065 60%, #7C3AED 80%, #A855F7 100%)', effect: 'cosmicNebula' }},
  99: { farSky: { gradient: 'linear-gradient(180deg, #fdf4ff 0%, #e0f2fe 25%, #bae6fd 50%, #7dd3fc 75%, #a78bfa 100%)', effect: 'crystalParadise' }},
  100: { farSky: { gradient: 'linear-gradient(180deg, #0c0a09 0%, #1c1917 20%, #292524 40%, #78716c 60%, #b8860b 80%, #f5d78e 100%)', effect: 'royalCitadel' }}
};

// Effect components map
const EFFECT_COMPONENTS = {
  fruitGarden: FruitGardenEffect,
  iceWorld: IceWorldEffect,
  chainRealm: ChainRealmEffect,
  chocolateFactory: ChocolateFactoryEffect,
  honeyHive: HoneyHiveEffect,
  lavaWorld: LavaWorldEffect,
  pointWorld: PointWorldEffect,
  darkForest: DarkForestEffect,
  oceanDepths: OceanDepthsEffect,
  frozenPeaks: FrozenPeaksEffect,
  ancientRuins: AncientRuinsEffect,
  volcanicCore: VolcanicCoreEffect,
  moonlightGarden: MoonlightGardenEffect,
  alchemistLab: AlchemistLabEffect,
  circusCarnival: CircusCarnivalEffect,
  pirateShipwreck: PirateShipwreckEffect,
  cherryBlossom: CherryBlossomEffect,
  stormKingdom: StormKingdomEffect,
  mushroomCavern: MushroomCavernEffect,
  casinoRoyale: CasinoRoyaleEffect,
  cosmicNebula: CosmicNebulaEffect,
  crystalParadise: CrystalParadiseEffect,
  royalCitadel: RoyalCitadelEffect
};

// Wrapper component with Suspense fallback
export function WorldEffect({ effectName }) {
  const EffectComponent = EFFECT_COMPONENTS[effectName];
  
  if (!EffectComponent) {
    return null;
  }
  
  return (
    <Suspense fallback={<div className="absolute inset-0" />}>
      <EffectComponent />
    </Suspense>
  );
}

export default WorldEffect;
